export default __webpack_public_path__ + "static/projects-details1-ac2a3c5fef9a4ce6673d8ee5360d3128.jpg";